import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { ButtonModule } from '@idocs/shared-ui/button';
import { BillingUiModule } from '@idocs/billing-ui';
import { NgxMaskModule } from 'ngx-mask';
import { IconStatusTextModule } from '@idocs/shared-ui/icon-status-text/icon-status-text.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BreadcrumbsModule } from '@idocs/shared-ui/breadcrumbs';

@NgModule({
    declarations: [DashboardLayoutComponent, DashboardComponent],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        ButtonModule,
        BillingUiModule,
        NgxMaskModule,
        IconStatusTextModule,
        BreadcrumbsModule,
    ],
})
export class DashboardModule {}
